import { Link } from "react-router-dom";
// reactstrap components
import { Navbar } from "reactstrap";

const MainNavbar = (props) => {
  // get the path for returning to the parent page
  // const parentPath = props.location.split("/").slice(0, 3).join("/");
  let parentPath = props.location.split("/");

  if (props.role === "admin") {
    parentPath = parentPath.slice(0, 3).join("/");
  } else {
    parentPath = parentPath.slice(0, 2).join("/");
  }

  console.log("parentPath", parentPath);

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Link
          className="h4 my-2 text-white text-uppercase d-inline-block"
          to={parentPath}
        >
          {props.pageTitle}
        </Link>
      </Navbar>
    </>
  );
};

export default MainNavbar;
